import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import httpInterceptor from "../../common/APIConfig";

const initialState = {
  resources: [],
  count: 0,
  loading: false,
  isloaded: false,
  error: false,
  errorMessage: null,
  errorAccountId: null,
};

export const getAllAWSDBs = createAsyncThunk(
  "getAllAWSDBs",
  async (accountId, { rejectWithValue }) => {
    try {
      const response = await httpInterceptor.get(
        `/resources/aws/rds?account=${accountId}`
      );
      if (response.status === 200) {
        return { accountId: accountId, dbs: response.data.dbs };
      }
    } catch (error) {
      console.log(error);
      if (!error.response) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllAWSDBsSlice = createSlice({
  name: "getAllAWSDBs",
  initialState,
  error: null,
  reducers: {
    resetGetAllAWSDBsError: (state) => {
      state.error = false;
      state.errorMessage = null;
      state.errorAccountId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAWSDBs.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = null;
      state.errorAccountId = null;
    });
    builder.addCase(getAllAWSDBs.fulfilled, (state, action) => {
      state.loading = false;
      state.resources = action.payload;
      state.isloaded = true;
      state.error = false;
      state.errorAccountId = null;
    });
    builder.addCase(getAllAWSDBs.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
      state.isloaded = true;
      state.error = true;
      state.errorAccountId =
        action.meta && action.meta.arg ? action.meta.arg : null;
    });
  },
});

export const { resetGetAllAWSDBsError } = getAllAWSDBsSlice.actions;

export default getAllAWSDBsSlice.reducer;
